import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { ForgotPaswordComponent } from './forgot-password/forgot-password.component';
import {ReactiveFormsModule } from '@angular/forms';
import { AuthorizationErrorComponent } from './authorization-error/authorization-error.component';
import { ResetPaswordComponent } from './forgot-password/reset-password.component';
import { OTPVerifyComponent } from './otp-verify/otp-verify.component';
import { CountdownModule } from 'ngx-countdown';
import { LinkExpiredComponent } from './link-expired/link-expired.component';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzNotificationModule } from 'ng-zorro-antd/notification';


@NgModule({
  declarations: [LoginComponent, ForgotPaswordComponent, AuthorizationErrorComponent, ResetPaswordComponent, OTPVerifyComponent, 
    LinkExpiredComponent],
  imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    CountdownModule,
    NzLayoutModule,
    NzInputModule,
    NzGridModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzCarouselModule,
    NzCardModule,
    NzIconModule,
    NzNotificationModule
  ]
})
export class AuthModule { }


